import { Element, useNode } from "@craftjs/core";
import StepIntro from "./components/Intro";
import StepTitle from "./components/Title";

const PageHeader = () => {
    const {
        connectors: { connect },
    } = useNode();

    return (
        <section id="page-hero" className="relative pt-[60px] mb-1" ref={(ref) => connect(ref!)}>
            <div className="container relative mx-auto 2xl:px-[108px] z-[1] mt-10">
                <h1 className="flex content-center gap-3 items-center">
                    <Element id="step-title" is={StepTitle} text="Spécifier les exigences" />
                </h1>
                <Element
                    id="step-intro"
                    is={StepIntro}
                    text=""
                />
            </div>
        </section>
    );
};

PageHeader.craft = {
    displayName: "Header",
    rules: {
        canDrag: () => false,
        canMoveOut: () => false,
    },
    custom: {
        canDelete: false,
    },
};

export default PageHeader;
